import React from 'react';
import { ButtonTertiary, cssColorValue, cssSpacing, IconArrowRight, screenXxsMax, Text, titleSmall, titleMedium, screenMdMax, bodyMediumBold, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { TWO_COLUMN_MAX_WIDTH, fadeInAnimation, withAnimationContext, DELAYS, } from '../../../ui';
import { useFrodorModules } from '../../../Context/FrodorModulesProvider';
import { descriptionsWithCTALgScreen } from './gridColumns';
import { formatText } from '../../../ui/utils';
const DescriptionWrapper = styled.div `
  display: flex;
  flex-direction: column;
  .eyebrow {
    padding-bottom: ${cssSpacing('base')};
  }
  padding-bottom: ${cssSpacing('looser')};
  // when two descriptions are present, add padding between them
  :first-of-type:not(:last-of-type) {
    padding-bottom: ${cssSpacing('looser-3')};
  }
  :first-of-type {
    .descriptionBody {
      ${titleMedium};
      @media (max-width: ${screenMdMax}) {
        ${titleSmall};
      }
      @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
        ${titleMedium};
      }
    }
  }
  // text styles for second description when present
  :last-of-type:not(:first-of-type) {
    .descriptionBody {
      ${titleSmall};
      @media (max-width: ${screenMdMax}) {
        ${bodyMediumBold};
      }
      @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
        ${titleSmall};
      }
    }
  }

  a {
    color: ${cssColorValue('textBase')};
    padding-block: 0 !important;
  }
`;
export const Description = ({ eyebrow, description, }) => {
    return (React.createElement(DescriptionWrapper, { className: "description" },
        React.createElement(Text, { className: "eyebrow", variant: "bodyMedium" }, eyebrow),
        React.createElement(Text, { className: "descriptionBody", dangerouslySetInnerHTML: {
                __html: formatText(description),
            } })));
};
export const DescriptionsAndCTAWrapper = withAnimationContext(styled.div `
  ${fadeInAnimation(DELAYS.FOURTH)};
  grid-column: ${descriptionsWithCTALgScreen};
  display: flex;
  flex-direction: column;
  align-items: start;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    width: 100%;
    grid-column: 1 / -1;
  }
  // aligntment for the CTA, center on small screens
  a,
  button {
    color: ${cssColorValue('textBase')};
    padding-block: ${cssSpacing('tighter-2')};
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
      justify-content: center;
    }
  }
`);
export const DescriptionsWithCTA = ({ primaryDescriptionEyebrow, primaryDescription, secondaryDescriptionEyebrow, secondaryDescription, ctaUrl, ctaText, ctaNewTab, }) => {
    const { InteractiveElement } = useFrodorModules();
    return (React.createElement(DescriptionsAndCTAWrapper, null,
        React.createElement(Description, { eyebrow: primaryDescriptionEyebrow, description: primaryDescription }),
        secondaryDescription && secondaryDescriptionEyebrow && (React.createElement(Description, { eyebrow: secondaryDescriptionEyebrow, description: secondaryDescription })),
        ctaUrl && ctaText && (React.createElement(InteractiveElement, { href: ctaUrl, target: ctaNewTab ? '_blank' : '_self', customComponent: ButtonTertiary, condensed: true, iconTrailing: IconArrowRight, trackingCategory: "module-dataHighlightModule", trackingLabel: `CTA Link - ${ctaText}` }, ctaText))));
};
